/** @jsx jsx */
import { jsx } from 'theme-ui'

export const Container = ({ children }) => (
  <div sx={{ maxWidth: 1290, m: '0 auto', px: 16 }}>{children}</div>
)
